import Table from "../../../core/common/dataTable/index";
import { Button } from "antd";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Loading from "../../../core/common/custom-loading/Loading";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
import { all_routes } from "../../router/all_routes";



interface GroupMember {
    member_id: number;
    organization_user_id: string;
    full_name: string;
    contact_number: string;
}


const ViewGroupMemebers = () => {
    //   const navigate = useNavigate();
    const { group_id } = useParams();
    // console.log(group_id);

    const routes = all_routes;
    // const data = leadsDataList;

    const [team, setTeam] = useState<any[]>([]);
    const [loading, setLoading] = useState(false)
    const [viewMember, setViewMember] = useState<GroupMember[]>([])
    // console.log("nananamyarjun122", team)

    const organizationId = localStorage.getItem("organization_id")
    // console.log("this is ogranization id is here", organizationId)

    const getViewGroupTeams = async () => {
        const payload = {
            group_id: group_id,
        };
        try {
            setLoading(true);
            const response = await AXIOSCONFIGMETHOD(
                "post",
                webServiceUrl.VIEW_GROUP_TEAMS,
                payload
            );
            console.log("getViewGroupTeams data ", response?.data);
            if (response?.success) {
                const result = response?.data;
                setViewMember(result);
                // console.log(result);

            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getViewGroupTeams();
    }, []);


    // const columns = [
    //     {

    //         title: "Employee ID",
    //         dataIndex: "employee_id",
    //         sorter: (a: any, b: any) => a.employee_id.length - b.employee_id.length,
    //     },
    //     {
    //         title: "Name",
    //         dataIndex: "full_name",
    //         render: (text: string) => text?.trim() ? text : "-",
    //         sorter: (a: any, b: any) => a.full_name.length - b.full_name.length,
    //     },


    //     {
    //         title: "Mobile No",
    //         dataIndex: "mobile_no",
    //         render: (text: string) => text?.trim() ? text : "-",
    //         sorter: (a: any, b: any) => a.mobile_no.length - b.mobile_no.length,
    //     },
    //     {
    //         title: "Email",
    //         dataIndex: "email_id",
    //         render: (text: string) => text?.trim() ? text : "-",
    //         sorter: (a: any, b: any) => a.email_id.length - b.email_id.length,
    //     },

    //     {
    //         title: "View Leads",
    //         dataIndex: "FollowupTrail",
    //         width: 150, // Set width in pixels (adjust as needed)
    //         // sorter: (a: any, b: any) => a.FollowupTrail.length - b.FollowupTrail.length,
    //         render: (_: any, record: any) => {
    //             return (
    //                 <button
    //                     //   onClick={() => {
    //                     //     console.log("my id is jhai", record.employee_id)
    //                     //     navigate('/sales-person-lead-list', { state: { employeeId: record.employee_id } });
    //                     //   }}
    //                     className="btn btn-sm w-50"
    //                     style={{ whiteSpace: 'nowrap', background: "#6b7280", color: "white" }}
    //                 >
    //                     View
    //                 </button>

    //             );
    //         },
    //     }

    // ]
    const columns = [
        // {
        //     title: "Member ID",
        //     dataIndex: "member_id",
        //     sorter: (a: GroupMember, b: GroupMember) => a.member_id - b.member_id,
        // },
        {
            title: "Sale User ID",
            dataIndex: "organization_user_id",
            render: (text: string) => text?.trim() ? text : "-",
            sorter: (a: GroupMember, b: GroupMember) =>
                a.organization_user_id.localeCompare(b.organization_user_id),
        },
        {
            title: "Full Name",
            dataIndex: "full_name",
            render: (text: string) => text?.trim() ? text : "-",
            sorter: (a: GroupMember, b: GroupMember) =>
                a.full_name.localeCompare(b.full_name),
        },
        {
            title: "Contact Number",
            dataIndex: "contact_number",
            render: (text: string) => text?.trim() ? text : "-",
            sorter: (a: GroupMember, b: GroupMember) =>
                a.contact_number.localeCompare(b.contact_number),
        },
        {
            title: "Activities",
            key: "view_members_activities",
            render: (_: any, record: any) => (
                <Link to={`/view-group-member/activities/${record.organization_user_id}`}>
                    <Button
                        // type="default"
                        onClick={() => {
                            // Replace with your API call to view members
                            console.log("View members activities of group", record.organization_user_id);
                        }}
                    >
                        View Activities
                    </Button>
                </Link>
            ),
        },
    ];


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">View Group Members </h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item"> <Link to={routes.leaddashboard}>
                                        Dashboard
                                    </Link></li>
                                
                                    <li className="breadcrumb-item active" aria-current="page">
                                        <Link to={routes.ManageSalesGroup}>
                                        Mange Sales Groups
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        View Members
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="me-2 mb-2">
                                <div className="d-flex align-items-center  p-0 me-auto">
                                </div>
                            </div>



                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    {/* Leads List */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5> Members List </h5>
                            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                                <div className="me-3">

                                </div>

                            </div>
                        </div>
                        {
                            loading ? (
                                <Loading />
                            ) : (
                                <div className="card-body p-0">
                                    <Table dataSource={viewMember} columns={columns}
                                    //    Selection={false}
                                    />
                                </div>
                            )
                        }
                    </div>
                    {/* /Leads List */}
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
                    <p className="mb-0">{new Date().getFullYear()} © Nestfin Technology. All rights reserved.</p>
                </div>
            </div>
            {/* /Page Wrapper */}
            {/* <CrmsModal/> */}
        </>

    )
}

// export default ViewGroupMemebers;
export default ViewGroupMemebers;